export const NUMBER_OF_DAYS: number = 20
export const NUMBER_OF_DAYS_MOBIL: number = 15

export const SUCCESS_COLOR: string = 'g'
export const SUCCESS_STREAK_COLOR: string = 'dg'
export const SUCCESS_FINISH_COLOR: string = 'f'
export const FAIL_COLOR: string = 'r'
export const FAIL_STREAK_COLOR: string = 'dr'

export const DAYS_TO_VALIDATE_STEP: number = 10
export const MAX_CONSECUTIVE_RED_NUMBER: number = 2
export const MAX_CONSECUTIVE_RED_NUMBER_WHILE_GREEN_STREAK: number = 3
export const TOO_MANY_REDS_NUMBER: number = 3
export const TOO_MANY_REDS_NUMBER_WHILE_GREEN_STREAK: number = 4

export const DEMO_ACCOUNT_USERNAME = 'Demo Account'
export const UNKNOWN_COLOR: string = 'u'
// number of consecutive unknown days from which they get collapsed into one cell
export const UNKNOWN_COLLAPSE_THRESHOLD: number = 3

// a habit day ends at 3:30 AM local time (clicks before that count for the previous day)
export const DAY_END_HOUR: number = 3
export const DAY_END_MINUTE: number = 30
